import React, { useRef, useState, useEffect } from "react";
import { VirtualizedExpandableTreeView } from "../tree-view/VirtualizedExpandableTreeView.js";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
import { AutocompleteInfoMessage } from "./AutocompleteInfoMessage.js";
import { AutocompletePlaceholder } from "./AutocompletePlaceholder.js";
import { FormAutocompleteInput } from "./FormAutocompleteInput.js";
import { useAutocompleteClientFilter, useAutocompleteState } from "./hooks.js";
function TreeAutocomplete({
  value,
  defaultOption,
  options,
  placeholder,
  emptyPlaceholder,
  subInfoMessage,
  errorMessage,
  onValueChange,
  onFilterChange,
  errorMessageOrientation,
  dataTestId,
  allowEmptyValue,
  mode = "client",
  listContainerClassName
}) {
  const { classes: styles, cx } = useAutocompleteClasses();
  const autocompleteRef = useRef(null);
  const [treeOptions, setTreeOptions] = useState([]);
  const flatOptions = getFlatOptions(options);
  const { filter } = useAutocompleteClientFilter();
  const { open, inputValue, autocompleteState, handleInputChange, handleBlur, handleKeyDown, handleClear, handleAutocompleteChange } = useAutocompleteState({
    value,
    defaultOption,
    options: flatOptions,
    onValueChange,
    onFilterChange: mode === "client" ? handleClientFilterChange : onFilterChange,
    allowFreeInputValue: false,
    allowEmptyValue,
    multiple: false,
    isAlwaysOpen: true,
    mode
  });
  useEffect(() => {
    handleClientFilterChange(inputValue);
  }, [flatOptions?.map((o) => o.value)?.join()]);
  function getFlatOptions(options2) {
    return options2?.length ? [options2, ...options2?.map((o) => getFlatOptions(o.subOptions)) ?? []]?.flat() : [];
  }
  function handleClientFilterChange(filterString) {
    const selected = flatOptions?.find((o) => o.value === value);
    setTreeOptions(
      selected?.value && selected?.label && inputValue === selected.label ? [{ value: selected.value, label: selected.label }] : filter(options, filterString)
    );
  }
  return /* @__PURE__ */ React.createElement("div", { className: styles.autocompleteContainer, "data-testid": dataTestId, ref: autocompleteRef }, /* @__PURE__ */ React.createElement(
    FormAutocompleteInput,
    {
      value: inputValue,
      onInputChange: handleInputChange,
      onBlur: handleBlur,
      clear: handleClear,
      placeholder,
      onKeyDown: handleKeyDown
    }
  ), treeOptions?.length ? /* @__PURE__ */ React.createElement("div", { className: cx(listContainerClassName, styles.autocompleteTreeViewList, styles.autocompleteViewList) }, /* @__PURE__ */ React.createElement(
    VirtualizedExpandableTreeView,
    {
      options: treeOptions,
      onItemClick: (value2) => handleAutocompleteChange(null, value2),
      selectedValue: value
    }
  )) : /* @__PURE__ */ React.createElement(AutocompletePlaceholder, { emptyPlaceholder }), /* @__PURE__ */ React.createElement(
    AutocompleteInfoMessage,
    {
      subInfoMessage,
      autocompleteState,
      hideMessage: open,
      containerRef: autocompleteRef,
      dataTestId: "autocompleteTreeErrorMessage",
      message: errorMessage,
      messageOrientation: errorMessageOrientation
    }
  ));
}
export {
  TreeAutocomplete
};
//# sourceMappingURL=TreeAutocomplete.js.map
